import type { IIconsVector } from 'shared/ui'
import type { ISidebarStatus } from 'pages/settings/pages/compliance/store/types'
import { CompliancePath } from '../../route/compliancePath'
import { LocalNumbersRoutes } from '../../pages/localNumbers'

export const statuses: Record<
  ISidebarStatus,
  { icon: IIconsVector; title: string; description?: string }
> = {
  success: {
    title: 'High chance of approval',
    icon: 'check2',
    description:
      "Great job! Your submission meets all key requirements. You're on the right track.",
  },
  medium: {
    title: 'Medium chance of approval',
    icon: 'alertTriangleYellow',
    description:
      'Your submission has a risk of being rejected by carriers. Please address the flagged issues to improve approval.',
  },
  low: {
    title: 'Low chance of approval',
    icon: 'alertTriangle',
    description:
      'Your submission has a high chance of being rejected by carriers. Please fix the flagged issues before submitting.',
  },
  error: {
    title: 'Something went wrong',
    icon: 'failed',
    description: 'Sorry, something went wrong there. Please try again.',
  },
}

export const siggestionStep: Record<string, number> = {
  useCaseData: 1,
  sampleMessagesData: 2,
  optInData: 4,
}

export const siggestionTitle: Record<string, string> = {
  description: 'Use case description',
  sampleMessage1: 'Sample message #1',
  sampleMessage2: 'Sample message #2',
  optInImages: 'Upload your opt-in image',
  onlineFormUrl: 'Online form URL',
  includeEmbeddedLinks: 'Include embedded links',
  includeAgeGatedContent: 'Include age-gated content',
  website: 'Privacy Policy',
  privacyPolicyUrl: 'Privacy Policy URL',
  termsUrl: 'Terms and Conditions URL',
}

export const siggestionRedirect: Record<number, string> = {
  1: `${CompliancePath.compliance.localNumbers.root}/${LocalNumbersRoutes.campaignUseCases}`,
  2: `${CompliancePath.compliance.localNumbers.root}/${LocalNumbersRoutes.messages}`,
  4: `${CompliancePath.compliance.localNumbers.root}/${LocalNumbersRoutes.optInOnlineFormContent}`,
}
